import messages from './messages';

export const PRODUCT_MODEL_TYPES = Object.freeze({
  NONE: 'NONE', // UI-only; never sent on RTM create/change requests
  CRX: 'CRX',
  AP_LABS: 'AP_LABS',
  ILAB: 'ILAB',
  ETEXT_BV_BRONTE: 'ETEXT_BV_BRONTE',
});

export const SELECTABLE_PRODUCT_MODELS = [
  PRODUCT_MODEL_TYPES.CRX,
  PRODUCT_MODEL_TYPES.AP_LABS,
  PRODUCT_MODEL_TYPES.ILAB,
  PRODUCT_MODEL_TYPES.ETEXT_BV_BRONTE,
];

export const PRODUCT_MODEL_LABEL_MESSAGES = {
  [PRODUCT_MODEL_TYPES.NONE]: messages.productModelNone,
  [PRODUCT_MODEL_TYPES.CRX]: messages.productModelCrx,
  [PRODUCT_MODEL_TYPES.AP_LABS]: messages.productModelApLabs,
  [PRODUCT_MODEL_TYPES.ILAB]: messages.productModelIlabs,
  [PRODUCT_MODEL_TYPES.ETEXT_BV_BRONTE]: messages.productModelEtextBvBronte,
};

const VALID_PRODUCT_MODELS = new Set(SELECTABLE_PRODUCT_MODELS);

export const isValidProductModel = (productModel) =>
  VALID_PRODUCT_MODELS.has(productModel);

export const getProductModelValue = (summary = {}, settings = {}) => {
  const productModel = summary.productModel || settings.productModel;
  return isValidProductModel(productModel) ? productModel : PRODUCT_MODEL_TYPES.NONE;
};

export const resolveProductModel = (cohort) => {
  const { productModel } = cohort || {};

  if (isValidProductModel(productModel)) {
    return productModel;
  }

  return PRODUCT_MODEL_TYPES.NONE;
};
